import {createButton} from "react-social-login-buttons";
 
const config = {
  icon: 'facebook',
  iconFormat: name => `fa fa-${name} social-fb`,
  style: { background: "white", color:"black" },
  activeStyle: { background: "white", opacity:'0.9' }
};
const FacebookButton = createButton(config);
 
export default FacebookButton;